import {useState, useCallback } from 'react';

import { useRecoilState } from 'recoil';
import { headerIndexState } from '../recoils/Header';

const MoveHeader = () => {
    const [headerIndex, setHeaderIndex] = useRecoilState(headerIndexState);

    return {headerIndex, setHeaderIndex};
}

export default MoveHeader
